import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Popconfirm,
  notification,
  Tooltip,
  Drawer,
  message,
  Tabs,
  Modal,
  Timeline,
  Tag,
  Spin,
} from "antd";
import {
  OrderedListOutlined,
  EditOutlined,
  DeleteOutlined,
  FormOutlined,
  EyeOutlined,
  FileExcelOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import QuoteTableFilter from "../Filters/QuoteTableFilter";
import moment from "moment";
import QuoteUpdateStatusForm from "./QuoteUpdateStatusForm";
import config from "../../util/ApiforContext";
import CompareQuotesModal from "./CompareQuotesModal";

const QuoteList = (props) => {
  const [options, setOptions] = useState({ pageTitle: "TEKLİF LİSTESİ" });
  const [quotes, setQuotes] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions(),
  );
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const history = useHistory();
  const [permissions, setPermissions] = useState({
    canAdd: false,
    canUpdate: false,
    canDelete: false,
    canApprove: false,
  });
  const [visible, setVisible] = useState(false);
  const [approvalHistoryModal, setApprovalHistoryModal] = useState(false);
  const [approvalHistory, setApprovalHistory] = useState({ data: [], loading: false });

  useEffect(() => {
    setFilterValues();
    getTableData();
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setQuotes({
      ...quotes,
      loading: true,
    });

    const { skip, take, filter, activeTab } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    let query = "";
    let conditions = ["Name ne 'Diğer'"];
    if (filter) {
      conditions.push(filter);
    }

    if (activeTab === "1") {
      conditions.push("isApproved eq true");
    } else if (activeTab === "2") {
      conditions.push("isRejected eq true");
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }

    if (activeTab === "0") {
      RequestHandler.get(
        `/Quote?$count=true${query}${order}&$skip=${skip}&$top=${take}`,
      ).then((response) => {
        setQuotes({
          data: response.value,
          loading: false,
          total: response["@odata.count"],
        });
      });
    } else if (activeTab === "1") {
      RequestHandler.get(
        `/Quote/GetApprovedHistoryListQueryableOdata?$count=true${query}${order}&$skip=${skip}&$top=${take}`,
      ).then((response) => {
        setQuotes({
          data: response,
          loading: false,
          total: response?.length || 0,
        });
      });
    } else if (activeTab === "2") {
      RequestHandler.get(
        `/Quote/GetApprovedHistoryListQueryableOdata?$count=true${query}${order}&$skip=${skip}&$top=${take}`,
      ).then((response) => {
        setQuotes({
          data: response,
          loading: false,
          total: response?.length || 0,
        });
      });
    }
  };

  const handleOnClickUpdate = (record) => {
    history.push({
      pathname: `/update-quote/${record.id}`,
    });
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);

    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  const handleOnClickDelete = (row) => {
    // if (row.addUserId !== localStorage.getItem("userId") && !isEditAllowed) {
    //   openNotificationForNotAuthWithIcon("warning");
    //   return;
    // }

    RequestHandler.delete(`/Quote/${row.id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const columns = [
    {
      title: "Teklif  Kodu",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Teklif Alınan Firma",
      dataIndex: "supplierName",
      key: "supplierName",
      align: "center",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Teklif Açıklaması",
      dataIndex: "description",
      key: "description",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: "Teslimat Tarihi",
      dataIndex: "deliveryDate",
      key: "deliveryDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY") : "-"),
    },

    {
      title: "Vade Gün Sayısı",
      dataIndex: "dueDayCount",
      key: "dueDayCount",
      render: (data) => (data ? data : "-"),
    },
    {
      title: "Talep Kodu",
      dataIndex: "purchaseRequestName",
      key: "purchaseRequestName",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Talebe Bağlı Proje Adı",
      dataIndex: "firmName",
      key: "firmName",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: "Ekleyen Kullanıcı",
      dataIndex: "addUserName",
      key: "addUserName",
    },
    {
      title: "Eklenme Tarihi",
      dataIndex: "addDate",
      key: "addDate",
      render: (data) =>
        data ? moment(data).format("DD.MM.YYYY HH:mm:ss") : "-",
    },
    {
      title: "Son Güncelleyen Kullanıcı",
      dataIndex: "updateUserName",
      key: "updateUserName",
    },

    {
      title: "Son Güncellenme Tarihi",
      dataIndex: "updateDate",
      key: "updateDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY HH:mm") : "-"),
    },

    {
      title: "Durum",
      dataIndex: "quoteStatusString",
      key: "quoteStatusString",
      render: (data, row) => {
        const content = row.statusByte === 4 && row.rejectReason ? (
          <Tooltip title={row.rejectReason}>
            <span>{data}</span>
          </Tooltip>
        ) : data;
        return (
          <Tag
            color={row.statusByte === 4 ? "red" : row.statusByte === 1 ? "green" : row.statusByte === 6 ? "orange" : "blue"}
            style={{ cursor: "pointer" }}
            onClick={() => handleShowApprovalHistory(row)}
          >
            <HistoryOutlined style={{ marginRight: 4 }} />
            {content}
          </Tag>
        );
      },
    },
    {
      title: "Görüntüle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        quotes.total >= 1 &&
        (row?.canApprove === true ||
          row.statusByte == 4 ||
          row?.statusByte == 6) ? (
          <a onClick={() => handleOnClickView(row)}>
            <EyeOutlined style={{ color: "blue", fontSize: "130%" }} />
          </a>
        ) : null,
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        quotes.total >= 1 && row?.canUpdate === true ? (
          <a onClick={() => handleOnClickUpdate(row)}>
            <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
          </a>
        ) : null,
    },
    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      render: (data, row) =>
        row?.canDelete === true ? (
          <Popconfirm
            title="Silmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleOnClickDelete(row)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <DeleteOutlined />
            </a>
          </Popconfirm>
        ) : null,
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
      activeTab: tableDataQueryOptions.activeTab,
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
        activeTab: tableDataQueryOptions.activeTab,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
        activeTab: tableDataQueryOptions.activeTab,
      };
    });
  };

  const dataStateChange = (e) => {
    setQuotes(e);
  };

  const handleActivePassive = (id) => {
    RequestHandler.delete(`/Quote/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const handleOnClickStatusUpdate = (row) => {
    setUpdateFormData({
      id: row.id,
      name: row.name,
      quoteStatus: row.statusByte,
    });
    setUpdateFormVisibility(true);
  };

  const handleOnClickView = (record) => {
    history.push({
      pathname: `/update-quote/${record.id}`,
      search: "?mode=view",
    });
  };

  const handleShowApprovalHistory = (record) => {
    setApprovalHistoryModal(true);
    setApprovalHistory({ data: [], loading: true });
    RequestHandler.get(`/PurchaseRequest/GetApprovalHistory/${record.id}/1`).then((res) => {
      setApprovalHistory({ data: res || [], loading: false });
    }).catch(() => {
      setApprovalHistory({ data: [], loading: false });
    });
  };

  const exportExcel = () => {
    const hide = message.loading("Excel indiriliyor...", 0);
    const { filter } = tableDataQueryOptions;
    RequestHandler.post(
      `/QuoteExcel/ExportExcel`,
      { Query: filter == "" ? "" : "$filter=" + filter },
      false,
      {
        rawResponse: true,
      },
    ).then((res) => {
      if (res.status == 200) {
        window.open(
          `${config.apiUrl}/QuoteExcel/DownloadExcelList?fileName=${
            res.data
          }&t=${RequestHandler.getToken()}`,
        );
      }
      hide();
    });
  };

  useEffect(() => {
    RequestHandler.get("/TenantUser/GetApprovalContext").then((res) => {
      if (res?.permissions?.quote) {
        setPermissions({
          canAdd: res?.isAdmin || res.permissions.quote.canAdd,
          canUpdate: res?.isAdmin || res.permissions.quote.canUpdate,
          canDelete: res?.isAdmin || res.permissions.quote.canDelete,
          canApprove: res?.isAdmin || res.permissions.quote.canApprove,
        });
      }
    });
  }, []);

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={12} lg={5} style={{ textAlign: "right" }}>
          <Button type="primary" onClick={() => setVisible(true)}>
            Teklifleri Karşılaştır
          </Button>
        </Col>
        <Col xs={24} md={12} lg={3} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={exportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
          <a href="/create-quote">
            <Button
              style={{ marginRight: 15 }}
              type="primary"
              hidden={!permissions.canAdd}
            >
              Teklif Ekle
            </Button>
          </a>
        </Col>
      </Row>

      <QuoteTableFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Tabs defaultActiveKey={"0"} onChange={onTabChange}>
        <Tabs.TabPane tab="Aktif" key="0" />
        <Tabs.TabPane tab="Onaylanan" key="1" />
        <Tabs.TabPane tab="Reddedilen" key="2" />
      </Tabs>

      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            dataSource={quotes.data}
            loading={quotes.loading}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: quotes.total,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>

      <Drawer
        id="updateQuoteDrawer"
        title="Durum Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <QuoteUpdateStatusForm data={updateFormData} onSuccess={onSuccess} />
      </Drawer>

      <CompareQuotesModal visible={visible} onClose={() => setVisible(false)} />

      <Modal
        title="Onay Geçmişi"
        visible={approvalHistoryModal}
        onCancel={() => setApprovalHistoryModal(false)}
        footer={null}
        width={700}
      >
        {approvalHistory.loading ? (
          <div style={{ textAlign: "center", padding: 40 }}>
            <Spin size="large" />
          </div>
        ) : approvalHistory.data.length === 0 ? (
          <Empty description="Onay geçmişi bulunamadı." />
        ) : (
          <Timeline mode="left" style={{ marginTop: 20 }}>
            {approvalHistory.data.map((item) => (
              <Timeline.Item
                key={item.id}
                color={item.isApproval ? "green" : item.isReject ? "red" : "blue"}
                dot={
                  item.isApproval ? (
                    <CheckCircleOutlined style={{ fontSize: 16 }} />
                  ) : item.isReject ? (
                    <CloseCircleOutlined style={{ fontSize: 16 }} />
                  ) : (
                    <InfoCircleOutlined style={{ fontSize: 16 }} />
                  )
                }
              >
                <div>
                  <strong>{item.userName}</strong>
                  <span style={{ color: "#999", marginLeft: 8 }}>
                    {moment(item.addDate).format("DD.MM.YYYY HH:mm")}
                  </span>
                </div>
                <div style={{ marginTop: 4 }}>
                  {item.approvalRoleName && (
                    <Tag color="default">{item.approvalRoleName}</Tag>
                  )}
                  {item.isApproval && <Tag color="success">Onayladı</Tag>}
                  {item.isReject && <Tag color="error">Reddetti</Tag>}
                  {!item.isApproval && !item.isReject && <Tag color="processing">Teklif Oluşturuldu</Tag>}
                </div>
                {item.nextStatusName && (
                  <div style={{ marginTop: 4, fontSize: 12, color: "#666" }}>
                    {item.nextStatusName}
                  </div>
                )}
                {item.reason && (
                  <div style={{ marginTop: 4, color: "#ff4d4f", fontSize: 12 }}>
                    <strong>Sebep:</strong> {item.reason}
                  </div>
                )}
              </Timeline.Item>
            ))}
          </Timeline>
        )}
      </Modal>
    </>
  );
};

export default QuoteList;
